import { clientAPI } from "@/lib/client-fetch";
import API_ENDPOINTS from "@/constants/api-endpoints";

export function trackAction(
  actionName: string,
  actionValue: string = "",
  additionalData: Record<string, unknown> = {}
): void {
  clientAPI.post(API_ENDPOINTS.TRACKED_ACTIONS, {
    action_name: actionName,
    action_value: actionValue,
    additional_data: additionalData,
  });
}
